module.exports = __webpack_public_path__ + "static/media/edit-2-light.86d850f2.svg";